import { api } from "data/api";

export const conversationApi = api.injectEndpoints({
  endpoints: builder => ({
    getConversation: builder.query({
      query: ({ conversationId }) => ({
        url: `/airbox/conversation/${conversationId}`,
        method: "GET"
      }),
      transformResponse: response => response?.thread
    }),
    sendMessage: builder.mutation({
      query: ({ conversationId, message }) => ({
        url: `/airbox/conversation/${conversationId}/message`,
        method: "POST",
        body: { body: message }
      })
    })
  })
});

export const { useGetConversationQuery, useSendMessageMutation } =
  conversationApi;
